import { DropList } from "../../../../../../../service/reportFolio/response";
import { DropListSubCategorie } from "../Context";

const findRequiredText = (
    dropDownLinks: any[],
    targetId: number
): boolean | undefined => {
    for (const link of dropDownLinks) {
        if (link.currentDropDownId === targetId) {
            return link.requiredText ?? false;
        }

        if (link.nextValues?.length) {
            const found = findRequiredText(link.nextValues, targetId);
            if (found !== undefined) return found;
        }
    }
    return undefined;
};

const parseDropListHierarchy = (value: {currentNode: number, id: number, name: string}[] | null, dropDownLinks: DropList[]): DropListSubCategorie[] => {
    try {
        const parsed = value;
        if (!Array.isArray(parsed) || parsed.length === 0) return [];

        let root: DropListSubCategorie = {
            label: parsed[0].name,
            value: parsed[0].id,
            requestText: findRequiredText(dropDownLinks, parsed[0].id) ?? false,
            dropList: [],
            currentNode: parsed[0].currentNode,
        };

        let current = root;

        for (let i = 1; i < parsed.length; i++) {
            const node = parsed[i];
            const newNode: DropListSubCategorie = {
                label: node.name,
                value: node.id,
                requestText: findRequiredText(dropDownLinks, node.id) ?? false,
                dropList: [],
                currentNode: node.currentNode,
            };
            current.dropList.push(newNode);
            current = newNode;
        }

        return [root];
    } catch {
        return [];
    }
};


export { parseDropListHierarchy }